<template>
    <div class="errorBox">
        <div class="error">
            <p>
                <img src="../assets/imgs/empty.png" alt=""></p>
            <p><a href="/">点击返回首页</a></p>
        </div>
    </div>
</template>

<script>
export default {
name: "empty"
}
</script>

<style scoped lang="scss">
.errorBox{display:flex;width: 100%;height: 100%;justify-content: center;align-items: center;
    .error{text-align: center;
        a{color:#0f820c;font-size: 16px;margin-top: 20px;}
    }
}
</style>